import { Expose } from "class-transformer";
import type { IProductHistory } from "../../../interfaces/IProductHistory";

export interface ISearchHistoryEntity {
  history: IProductHistory[];
}

export class SearchHistoryEntity implements ISearchHistoryEntity {
  @Expose()
  history!: IProductHistory[];

  constructor(history?: IProductHistory[]) {
    if (history) {
      this.history = history;
    }
  }
}
